import AttendeeAction from '../attendeeAction';

import { Attendee } from '../../../../models';

export default class SendModerationStatusAction extends AttendeeAction {
    static NAME = 'send_moderation_status';
    static MODAL_SUBTITLE = 'ticket.manager.attendees.action.send_moderation_status.subtitle';
    static ASYNCHRONOUS_LIMIT_MIN = 50;

    static is_available({ event }) {
        return event.is_moderation_enabled && !['over', 'closed'].includes(event.status) && !event.removed;
    }
    static condition(attendee) {
        return !attendee.removed;
    }
    static is_attendee_valid({ attendee }) {
        return !attendee.removed;
    }

    run({ attendees = null, orders = null }) {
        if (orders) {
            this.filtered_orders = orders;
            this.filtered_attendees = [];
            orders.forEach(element => {
                this.filtered_attendees = this.filtered_attendees.concat(element.attendees);
            });
        } else {
            this.filtered_attendees = attendees || this.filtered_items;
        }

        return Attendee.perform_action(
            this.constructor.NAME,
            this.filtered_attendees,
            { organization: this.organization, event: this.event },
            this.isAsync(this.filtered_attendees)
        );
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }

    get post_action() {
        return false;
    }

    get withToastRun() {
        return true;
    }
}
